<div class="card card-well top-buffer animate__animated animate__fadeIn animate__faster">
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2">
      <ziro-stacked-icon
        [stackedIcon]="ZiroStackedIcons[ziroIcons.CHANGE_SITE]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <span>{{ 'tkey;operations.menu.change_site.text' | translate }}</span>
    </legend>

    <ziro-select [fieldId]="'site'"></ziro-select>

    @if (isValidCluster) {
      <div [attr.data-automation]="'warning-container'">
        <hr />
        <p [innerHTML]="'tkey;change_site.public_phone.warning.device_pool.text' | escapeHtml"></p>
        <div class="alert alert-warning">
          <i [ngClass]="ziroIcons.WARNING_TRIANGLE + ' me-1'"></i>
          <strong>{{ 'tkey;change_site.public_phone.warning.post_change.text' | translate }}</strong>
        </div>
        <p>
          <strong>{{ 'tkey;change_site.public_phone.warning.continue.text' | translate }}</strong>
        </p>
        <hr />
      </div>
    }
    <div class="text-end">
      @if (!isSubmitting && isFormSubmitted && validationState === ValidationState.INVALID) {
        <div>
          <div
            class="alert ziro-error-notification alert-danger animate__animated animate__shakeX text-start"
            role="alert"
          >
            <i [class]="ziroIcons.EXCLAMATION" class="fa-lg"></i>
            <span class="strong">
              {{ 'tkey;validators.global.required.missing.error' | translate }}
            </span>
          </div>
        </div>
      }

      <ziro-button
        [dataAutomation]="'public-phone-change-site-cancel-button'"
        [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
        [label]="'tkey;dialogs.button.cancel'"
        [cssClass]="'me-1'"
        [isDisabled]="isSubmitting"
        (clicked)="onCancelClicked()"
      ></ziro-button>
      <ziro-submit-button
        [isPending]="isSubmitting"
        [dataAutomation]="'public-phone-change-site-button'"
        [iconPending]="ziroIcons.SAVING"
        [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
        [label]="'tkey;change.site.change_site'"
        [formSubmitSubject]="_validateAndSubmitSource"
      ></ziro-submit-button>
    </div>
  </div>
</div>
